export const config = {
    // SERVER_BASE_URL: "http://localhost:5000"
    SERVER_BASE_URL: "https://api-photo-app.supralabs.online"
}